import React from 'react';
import AppCheckbox from 'components/FormElements/AppCheckBox';
import { z } from 'zod';
import { eisFirm as rules } from 'further-ui/validations';
import { styled, Tooltip, Box } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

type FormValues = z.infer<typeof rules.UpdateEisPortalAndKycSettingsInput>;

type ClassificationCheckboxProps = {
  label: string;
  fieldKey: keyof FormValues['whiteLabelConfig']['permittedClassifications'];
  currentValue: FormValues['whiteLabelConfig']['permittedClassifications'];
  onChange: (
    value: FormValues['whiteLabelConfig']['permittedClassifications'],
  ) => void;
  error?: boolean;
  errorMessage?: string;
  tooltip?: React.ReactNode;
  disabled?: boolean;
};

const StyledTooltipIcon = styled(InfoOutlined)({
  fontSize: '16px',
  cursor: 'pointer',
});

const StyledContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const StyledAppCheckbox = styled(AppCheckbox)<{ hasTooltip?: boolean }>(
  ({ hasTooltip }) => ({
    '& .MuiFormControlLabel-root': {
      marginRight: hasTooltip ? '8px' : '16px',
    },
  }),
);

const ClassificationCheckbox: React.FC<ClassificationCheckboxProps> = ({
  label,
  fieldKey,
  currentValue,
  onChange,
  error,
  errorMessage,
  tooltip,
  disabled = false,
}) => (
  <StyledContainer>
    <StyledAppCheckbox
      label={label}
      checked={currentValue[fieldKey]}
      disabled={disabled}
      onChange={(e) =>
        onChange({
          ...currentValue,
          [fieldKey]: e.target.checked,
        })
      }
      error={!!error}
      helperText={errorMessage}
      hasTooltip={!!tooltip}
    />
    {tooltip && (
      <Tooltip leaveDelay={250} arrow title={tooltip}>
        <StyledTooltipIcon />
      </Tooltip>
    )}
  </StyledContainer>
);

export default ClassificationCheckbox;
